import { render, staticRenderFns } from "./RenderArticles.vue?vue&type=template&id=c4cc434c&"
import script from "./RenderArticles.vue?vue&type=script&lang=js&"
export * from "./RenderArticles.vue?vue&type=script&lang=js&"
import style0 from "./RenderArticles.vue?vue&type=style&index=0&id=c4cc434c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports